import { UsersTable } from "@/components/admin/UsersTable";
import { SettingsLayout } from "@/components/layout/SettingsLayout";

export function SettingsUsersPage() {
  return (
    <SettingsLayout>
      <UsersTable />
    </SettingsLayout>
  );
}
